// extracted by mini-css-extract-plugin
module.exports =  {"secret":"rdNV26Z3XWLDvxyvagS3"};